[
  {
    "name": "Regina Ruiz",
    "birthdate": "08/06/2006",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/307810668.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 173,
    "draftJersey": 1,
    "macros": {
      "reflexes": 96,
      "diving": 87,
      "duels": 78,
      "passing": 74,
      "handling": 96,
      "anticipation": 83,
      "average": 83
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "3ZmTJ2P6XIU"
  },
  {
    "name": "Frida Rivera",
    "birthdate": "21/05/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/111653360.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 160,
    "draftJersey": 2,
    "macros": {
      "reflexes": 78,
      "diving": 87,
      "duels": 78,
      "passing": 61,
      "handling": 87,
      "anticipation": 74,
      "average": 75
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "kP5j9JGesds"
  },
  {
    "name": "Angelica Vazquez",
    "birthdate": "22/11/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/616974774.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 170,
    "draftJersey": 3,
    "macros": {
      "reflexes": 96,
      "diving": 97,
      "duels": 79,
      "passing": 71,
      "handling": 88,
      "anticipation": 82,
      "average": 82
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "Dla5gO9FKtU"
  },
  {
    "name": "Lizet Rovira",
    "birthdate": "13/11/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/8662443.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 4,
    "macros": {
      "reflexes": 96,
      "diving": 79,
      "duels": 79,
      "passing": 52,
      "handling": 88,
      "anticipation": 73,
      "average": 77
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "3VlTEOu68U0"
  },
  {
    "name": "Fernanda Yepiz",
    "birthdate": "12/12/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/948086907.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 5,
    "macros": {
      "reflexes": 78,
      "diving": 96,
      "duels": 69,
      "passing": 59,
      "handling": 87,
      "anticipation": 74,
      "average": 74
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "RUwzQI4pyKc"
  },
  {
    "name": "Alinne Alvarado",
    "birthdate": "20/08/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/205989077.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 169,
    "draftJersey": 6,
    "macros": {
      "reflexes": 87,
      "diving": 87,
      "duels": 78,
      "passing": 64,
      "handling": 87,
      "anticipation": 77,
      "average": 78
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "SZIblJdLSdE"
  },
  {
    "name": "Alexia Laimon",
    "birthdate": "10/06/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/146376554.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 171,
    "draftJersey": 7,
    "macros": {
      "reflexes": 87,
      "diving": 78,
      "duels": 96,
      "passing": 66,
      "handling": 78,
      "anticipation": 77,
      "average": 79
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "ObH6pbAuvDU"
  },
  {
    "name": "Haydee Dorantes",
    "birthdate": "05/03/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/315363922.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 157,
    "draftJersey": 8,
    "macros": {
      "reflexes": 96,
      "diving": 87,
      "duels": 78,
      "passing": 65,
      "handling": 87,
      "anticipation": 79,
      "average": 80
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "xkug5VHiUO0"
  },
  {
    "name": "Yatziri Benítez",
    "birthdate": "06/05/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/676919213.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 172,
    "draftJersey": 9,
    "macros": {
      "reflexes": 69,
      "diving": 78,
      "duels": 78,
      "passing": 69,
      "handling": 78,
      "anticipation": 73,
      "average": 71
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "338I2LSwDhs"
  },
  {
    "name": "Karla Cazares",
    "birthdate": "08/06/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/920081074.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 165,
    "draftJersey": 10,
    "macros": {
      "reflexes": 79,
      "diving": 96,
      "duels": 96,
      "passing": 69,
      "handling": 96,
      "anticipation": 83,
      "average": 84
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "Cy4eHDOpd5g"
  },
  {
    "name": "Areli Sánchez",
    "birthdate": "13/10/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/650253800.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 170,
    "draftJersey": 59,
    "macros": {
      "reflexes": 79,
      "diving": 88,
      "duels": 70,
      "passing": 76,
      "handling": 88,
      "anticipation": 77,
      "average": 76
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "t_b2kcDOE3g"
  },
  {
    "name": "Daniela García",
    "birthdate": "02/06/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/238400446.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 166,
    "draftJersey": 60,
    "macros": {
      "reflexes": 88,
      "diving": 88,
      "duels": 70,
      "passing": 85,
      "handling": 70,
      "anticipation": 79,
      "average": 74
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "zeBZa4PSlGg"
  },
  {
    "name": "Alejandra Salgado",
    "birthdate": "02/07/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/6047417.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 61,
    "macros": {
      "reflexes": 78,
      "diving": 97,
      "duels": 79,
      "passing": 70,
      "handling": 97,
      "anticipation": 80,
      "average": 80
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "5zBn1Kp6OCQ"
  },
  {
    "name": "Jennipher Esquivel",
    "birthdate": "02/03/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/777798980.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 62,
    "macros": {
      "reflexes": 96,
      "diving": 78,
      "duels": 87,
      "passing": 69,
      "handling": 78,
      "anticipation": 79,
      "average": 79
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "VPhDE6rXrLs"
  },
  {
    "name": "Alejandra Hernández",
    "birthdate": "27/08/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/617130821.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 156,
    "draftJersey": 63,
    "macros": {
      "reflexes": 68,
      "diving": 69,
      "duels": 87,
      "passing": 56,
      "handling": 87,
      "anticipation": 70,
      "average": 72
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "uzFarkiA99A"
  },
  {
    "name": "Azucena Ginez",
    "birthdate": "15/12/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/749348334.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 64,
    "macros": {
      "reflexes": 78,
      "diving": 70,
      "duels": 88,
      "passing": 64,
      "handling": 88,
      "anticipation": 74,
      "average": 76
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "JpbPzSb4B-s"
  },
  {
    "name": "Mariana Zárraga",
    "birthdate": "29/05/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/273134353.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 164,
    "draftJersey": 66,
    "macros": {
      "reflexes": 70,
      "diving": 88,
      "duels": 97,
      "passing": 76,
      "handling": 97,
      "anticipation": 82,
      "average": 83
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "ecNkCDlND8c"
  },
  {
    "name": "Romina Gomar",
    "birthdate": "11/03/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/900982598.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 174,
    "draftJersey": 68,
    "macros": {
      "reflexes": 87,
      "diving": 88,
      "duels": 88,
      "passing": 67,
      "handling": 88,
      "anticipation": 80,
      "average": 81
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "s5gTpMpnBug"
  },
  {
    "name": "Paulina Gutiérrez",
    "birthdate": "14/02/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/602372864.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 117,
    "macros": {
      "reflexes": 87,
      "diving": 97,
      "duels": 79,
      "passing": 80,
      "handling": 88,
      "anticipation": 83,
      "average": 81
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "yZQW_18h9ts"
  },
  {
    "name": "Katia García",
    "birthdate": "19/12/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/677699937.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 119,
    "macros": {
      "reflexes": 69,
      "diving": 78,
      "duels": 78,
      "passing": 51,
      "handling": 87,
      "anticipation": 68,
      "average": 71
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "sbxqcOAPTx8"
  },
  {
    "name": "Luisa Villaseñor",
    "birthdate": "05/11/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/491822249.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 165,
    "draftJersey": 121,
    "macros": {
      "reflexes": 86,
      "diving": 78,
      "duels": 69,
      "passing": 73,
      "handling": 87,
      "anticipation": 77,
      "average": 75
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "Y-hB4Q81gss"
  },
  {
    "name": "Anna Jiménez",
    "birthdate": "10/02/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/135467403.png",
    "country": "Spain",
    "role": "PT",
    "foot": "right",
    "height": 175,
    "draftJersey": 122,
    "macros": {
      "reflexes": 78,
      "diving": 96,
      "duels": 87,
      "passing": 51,
      "handling": 78,
      "anticipation": 73,
      "average": 75
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "H7nIiXKdDtc"
  },
  {
    "name": "Karla Quesada",
    "birthdate": "31/03/2006",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/152440733.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 168,
    "draftJersey": 123,
    "macros": {
      "reflexes": 96,
      "diving": 60,
      "duels": 78,
      "passing": 64,
      "handling": 78,
      "anticipation": 73,
      "average": 74
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "HCLTKbujtvU"
  },
  {
    "name": "Erika Lázaro",
    "birthdate": "05/08/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/135928539.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 153,
    "draftJersey": 125,
    "macros": {
      "reflexes": 69,
      "diving": 78,
      "duels": 60,
      "passing": 59,
      "handling": 78,
      "anticipation": 67,
      "average": 65
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "TcxTWrAnvrI"
  },
  {
    "name": "Daniela Robles",
    "birthdate": "24/01/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/130060770.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 162,
    "draftJersey": 126,
    "macros": {
      "reflexes": 77,
      "diving": 96,
      "duels": 87,
      "passing": 64,
      "handling": 78,
      "anticipation": 77,
      "average": 76
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "MIt00PXHLog"
  },
  {
    "name": "Mora Orloff",
    "birthdate": "04/01/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/48713298.png",
    "country": "Argentina",
    "role": "PT",
    "foot": "right",
    "height": 165,
    "draftJersey": 175,
    "macros": {
      "reflexes": 96,
      "diving": 79,
      "duels": 88,
      "passing": 66,
      "handling": 88,
      "anticipation": 79,
      "average": 81
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "3-Xvu8FvHng"
  },
  {
    "name": "Ana López",
    "birthdate": "09/12/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/947698066.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 163,
    "draftJersey": 176,
    "macros": {
      "reflexes": 87,
      "diving": 79,
      "duels": 79,
      "passing": 61,
      "handling": 88,
      "anticipation": 74,
      "average": 76
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "0o8F8_GQzDg"
  },
  {
    "name": "Fabiola Sandoval",
    "birthdate": "05/04/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/281668405.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 177,
    "draftJersey": 178,
    "macros": {
      "reflexes": 87,
      "diving": 79,
      "duels": 79,
      "passing": 71,
      "handling": 79,
      "anticipation": 76,
      "average": 75
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "icrHCx0S_So"
  },
  {
    "name": "Brissa Rangel",
    "birthdate": "24/06/1990",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/44205953.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 169,
    "draftJersey": 179,
    "macros": {
      "reflexes": 78,
      "diving": 88,
      "duels": 88,
      "passing": 75,
      "handling": 97,
      "anticipation": 82,
      "average": 82
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "iE6SwnQMaS8"
  },
  {
    "name": "Jennifer Alvarado",
    "birthdate": "20/09/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/616614594.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 154,
    "draftJersey": 181,
    "macros": {
      "reflexes": 87,
      "diving": 88,
      "duels": 97,
      "passing": 75,
      "handling": 88,
      "anticipation": 83,
      "average": 84
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "Y80PBwVTvm0"
  },
  {
    "name": "Berenice Hurtado",
    "birthdate": "17/12/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/196528103.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 171,
    "draftJersey": 183,
    "macros": {
      "reflexes": 96,
      "diving": 87,
      "duels": 69,
      "passing": 66,
      "handling": 78,
      "anticipation": 76,
      "average": 75
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "HVTEeeUQrSo"
  },
  {
    "name": "Samantha Romero",
    "birthdate": "01/08/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/588981788.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 164,
    "draftJersey": 184,
    "macros": {
      "reflexes": 96,
      "diving": 69,
      "duels": 87,
      "passing": 56,
      "handling": 69,
      "anticipation": 71,
      "average": 74
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "4r3dV3iygAw"
  },
  {
    "name": "Selene Minaya",
    "birthdate": "08/01/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/441890885.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 160,
    "draftJersey": 233,
    "macros": {
      "reflexes": 79,
      "diving": 88,
      "duels": 79,
      "passing": 71,
      "handling": 88,
      "anticipation": 77,
      "average": 77
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "lNjkEqrZsvs"
  }
]
